const NAV_EVENT = 'bravic:navigate'

export function navigate(path: string) {
  if (typeof window === 'undefined') return
  const currentPath = window.location.pathname
  if (currentPath === path) {
    window.scrollTo(0, 0)
    return
  }
  const search = window.location.search
  window.history.pushState({}, '', path + search)
  window.dispatchEvent(new Event(NAV_EVENT))
  window.scrollTo(0, 0)
}

export function getPath(): string {
  if (typeof window === 'undefined') return '/'
  return window.location.pathname || '/'
}

export function onPathChange(handler: () => void): () => void {
  window.addEventListener('popstate', handler)
  window.addEventListener(NAV_EVENT, handler)
  return () => {
    window.removeEventListener('popstate', handler)
    window.removeEventListener(NAV_EVENT, handler)
  }
}

export function redirectLegacyHash(): void {
  if (typeof window === 'undefined') return
  const hash = window.location.hash
  if (!hash || !hash.startsWith('#/')) return
  const [pathPart, queryPart] = hash.slice(1).split('?')
  const path = pathPart || '/'
  const search = queryPart ? `?${queryPart}` : window.location.search
  window.history.replaceState({}, '', path + search)
}
